'use client'

import { useEffect } from 'react'
import { usePathname } from 'next/navigation'

import { normalizePath } from '@/lib/analytics/events'
import type { XdmContext } from '@/lib/analytics/xdm'

import { publishPageMeta } from './page-meta'

export type AnalyticsPageViewProps = {
  path?: XdmContext['path']
  pageTitle?: XdmContext['pageTitle']
  contentType?: XdmContext['contentType']
  vendor?: XdmContext['vendor']
  category?: XdmContext['contentCategory']
  subCategories?: XdmContext['contentSubcategories']
  isErrorPage?: XdmContext['isErrorPage']
  emitArticleSource?: boolean
}

export function AnalyticsPageView({
  path,
  pageTitle,
  contentType,
  vendor,
  category,
  subCategories,
  isErrorPage,
  emitArticleSource,
}: AnalyticsPageViewProps) {
  const pathname = usePathname()
  const resolvedPath = normalizePath(path ?? pathname ?? '')

  useEffect(() => {
    publishPageMeta({
      path: resolvedPath,
      articleSource: emitArticleSource,
      context: {
        pageTitle,
        contentType,
        vendor,
        contentCategory: category,
        contentSubcategories: subCategories?.length ? subCategories : undefined,
        isErrorPage,
      },
    })
  }, [
    resolvedPath,
    pageTitle,
    contentType,
    vendor,
    category,
    subCategories,
    isErrorPage,
    emitArticleSource,
  ])

  return null
}
